import React from "react";
import DaoTabsComponent from "./dao-tabs-component";

const DaoPageComponent = () => {
  return (
    <>
      <div className="py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="page-title-wrapper mb-8">
            <h1 className="m-0 text-xl sm:text-3xl font-medium text-center text-black uppercase">
              welcome to <span className="title-stroke">BAF</span> DAO
            </h1>
          </div>
          <div className="flex flex-col lg:flex-row">
            <DaoTabsComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default DaoPageComponent;
